import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { authApi } from "@/utils/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_propmatch-7/artifacts/y6a3qiy4_LogotipoFinal_IkonicDeals%28web%29.jpg";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authApi.login(formData.email, formData.password);
      toast.success("Bienvenido al panel de administracion");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Ikonic Deals" className="h-16 mx-auto mb-6" />
          <h1 className="text-2xl text-white">Panel de Administracion</h1>
          <p className="text-[#A3A3A3] mt-2">Ingresa tus credenciales para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#121212] border border-white/5 p-8 space-y-6">
          <div>
            <label className="block text-sm text-[#A3A3A3] mb-2">Email</label>
            <Input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="admin@ikonicdeals.com"
              className="h-12 bg-black/40 border-white/10 text-white placeholder:text-white/40"
              data-testid="login-email"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-[#A3A3A3] mb-2">Contrasena</label>
            <div className="relative">
              <Input
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="••••••••"
                className="h-12 bg-black/40 border-white/10 text-white placeholder:text-white/40 pr-12"
                data-testid="login-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#D4AF37] text-black hover:bg-[#FFE082] font-medium"
            data-testid="login-submit"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Iniciar Sesion"}
          </Button>
          
          <div className="text-center">
            <Link 
              to="/panel-gestion-8k2m/recuperar" 
              className="text-[#A3A3A3] hover:text-[#D4AF37] transition-colors text-sm"
              data-testid="forgot-password-link"
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </form>

        <p className="text-center mt-6 text-[#525252] text-sm">
          <a href="/" className="hover:text-[#D4AF37] transition-colors">
            ← Volver al sitio
          </a>
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
